import {
  isPodcastReportingEnabledForCountry,
  isTracksReportingEnabledForCountry,
} from 'components/ContentReporting/market-helper';
import { EntityType as CommonEntityType } from 'proto/generated/spotify/catalogmanagement/entity/v1/entity';
import { ContentType } from 'proto/generated/tintin_content_policy';

import { AssetType } from '../../../../../proto/generated/spotify/catalogmanagement/entity/v1/asset';

import { EntityTypesWithAssetTypes } from './contentType';

export const withFullTranslationKey = (translationKey?: string): string => `content_policy_reporting:${translationKey}`;
export const removeFullTranslationKey = (value: string): string => value.replace(/content_policy_reporting:/gi, '');

export const getReportingInstructionKey = (userCountryIsoCode: string) => {
  const isPodcastReportingEnabled = isPodcastReportingEnabledForCountry(userCountryIsoCode);
  const isTracksReportingEnabled = isTracksReportingEnabledForCountry(userCountryIsoCode);

  if ([isPodcastReportingEnabled, isTracksReportingEnabled].every(Boolean)) {
    return null;
  }

  if (isPodcastReportingEnabled && !isTracksReportingEnabled) {
    return 'to_report_on_podcast_reporting_enabled';
  }

  if (!isPodcastReportingEnabled && isTracksReportingEnabled) {
    return 'to_report_on_podcast_with_track_disabled';
  }

  return 'to_report_on_podcast_reporting';
};

export const shouldShowTrackHelperText = (
  isEmployee: boolean,
  entityType: keyof typeof CommonEntityType,
  entityTypesWithAssetTypes: EntityTypesWithAssetTypes,
) => {
  if (isEmployee || !entityType) {
    return false;
  }
  return (
    CommonEntityType[entityType] === CommonEntityType.TRACK &&
    !entityTypesWithAssetTypes[CommonEntityType[entityType]]?.includes({
      contentType: ContentType.CONTENT_TYPE_AUDIO,
      commonAssetType: AssetType.AUDIO,
    }) &&
    !entityTypesWithAssetTypes[CommonEntityType[entityType]]?.includes({
      contentType: ContentType.CONTENT_TYPE_MUSIC_STORYLINES,
      commonAssetType: AssetType.STORYLINE,
    })
  );
};
